module.exports = __webpack_public_path__ + "media/custom-font-icon/icomoon-be05bd99.ttf";